import { getPageDescriptor, getPageContent } from '@pm2/api';
import { pageParsers } from '@pm2/content-engine';
import { getRevisionByIdRequest } from '@pm2/course-revisions';
import { xml2ast, findInAST } from '@utils/ast';

async function getLocationDataRequest(config, descriptor) {
  if (!descriptor) {
    return null;
  }
  if (descriptor.version !== "1") {
    throw new Error(`getLocationDataRequest(): Invalid version received, only '1' is currently supported. Received: '${descriptor.version}'`);
  }
  switch (descriptor.type) {
    case "page":
      {
        const data = await getPageDescriptor(config.config, descriptor.pageId, {
          previewMode: config.previewMode
        });
        if (!data) {
          return null;
        }
        const vignette = await resolveVignette(config, data);
        return {
          ...descriptor,
          path: data.path,
          title: data.title,
          vignette
        };
      }
    case "course":
      {
        const [courseDescriptor, chapterDescriptor, revision] = await Promise.all([getPageDescriptor(config.config, descriptor.courseId, {
          previewMode: config.previewMode
        }), descriptor.chapterId ? await getPageDescriptor(config.config, descriptor.chapterId, {
          previewMode: config.previewMode
        }) : undefined, descriptor.revisionId ? await getRevisionByIdRequest(descriptor.revisionId).catch(err => console.error(err)) : undefined]);
        if (!courseDescriptor) {
          return null;
        }
        const path = `${chapterDescriptor?.path ?? courseDescriptor.path}?revisionId=${revision?.id ?? courseDescriptor.id}&revisionTitle=${revision?.name ?? ""}`;
        return {
          ...descriptor,
          path,
          title: courseDescriptor.title,
          chapterTitle: chapterDescriptor?.title,
          vignette: (await resolveVignette(config, courseDescriptor)) ?? (await resolveVignette(config, chapterDescriptor))
        };
      }
  }
}
async function resolveVignette(config, descriptor) {
  if (!descriptor) {
    return undefined;
  }
  if (descriptor.vignette) {
    return descriptor.vignette;
  }
  const content = xml2ast(await getPageContent(config.config.id, descriptor.id, {
    previewMode: config.previewMode
  }), pageParsers);
  const node = findInAST(content, node => node.nodeType === "image-component" || node.nodeType === "split-component");
  switch (node?.nodeType) {
    case "image-component":
      return {
        url: node.imageSrc,
        width: node.meta.imageWidth,
        height: node.meta.imageHeight,
        alt: node.meta.alt
      };
    case "split-component":
      return {
        url: node.image.imageSrc,
        width: node.image.meta.imageWidth,
        height: node.image.meta.imageHeight,
        alt: node.image.meta.alt
      };
  }
}

export { getLocationDataRequest };
//# sourceMappingURL=get-data.request.js.map
